import * as React from "react";
import AreaTitle from "../AreaTitle/index";
import { Redirect, Route } from "react-router-dom";
import InternalRedirect from "../Navigation/InternalRedirect/InternalRedirect";
import routeLinks from "../../routeLinks";

const notFoundImage = require("./notfound.png");
const styles = require("./style.less");

const RedirectAs404 = () => <Route render={({ location }) =>
    <InternalRedirect to={{ ...location, state: { is404: true } }} />} />;

const NotFound = () =>
    <main id="maincontent">
        <AreaTitle
            link={routeLinks.root}
            title="Page not found"
        />
        <div className={styles.container}>
            <img src={notFoundImage} alt="Page couldn't be found" />
            <h4>Page not found.</h4>
            <p>Sorry, the page you are looking for could not be found.</p>
        </div>
    </main>;

export { NotFound, RedirectAs404 };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/NotFound/NotFound.tsx